import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ImagePlus } from "lucide-react";
import { ACCEPT, api, errMsg } from "@/lib/api";
import { PermissionCheck } from "@/components/Provenance";

export default function Contribute() {
  const { token } = useParams();
  const ref = useRef(null);
  const [info, setInfo] = useState(null);
  const [perm, setPerm] = useState(false);
  const [done, setDone] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/contribute/${token}`).then((r) => setInfo(r.data)).catch(() => setErr("This invite link isn't valid.")); }, [token]);
  const upload = async (files) => {
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("permission", "true");
      try { await api.post(`/contribute/${token}/photos`, fd); setDone((d) => [...d, f.name]); } catch (e) { setErr(errMsg(e, "Upload didn't finish.")); }
    }
  };
  return (
    <main className="mx-auto max-w-xl px-5 py-16" data-testid="contribute-page">
      <div className="eyebrow mb-3">You've been invited</div>
      <h1 className="font-display text-4xl tracking-tight">Add your photos of {info?.propertyTitle || "this place"}</h1>
      <p className="mt-3 text-sm text-[var(--ink-soft)]">This link can only add photos to the workspace. It can't view or change anything else.</p>
      <div className="mt-8"><PermissionCheck checked={perm} onChange={setPerm} testid="contribute-permission-checkbox" /></div>
      <button className="btn-primary mt-3" disabled={!perm || !info} onClick={() => ref.current?.click()} data-testid="contribute-upload-button"><ImagePlus size={16} /> Upload photos</button>
      <input ref={ref} type="file" multiple accept={ACCEPT} className="hidden" data-testid="contribute-photo-input" onChange={(e) => { const f = Array.from(e.target.files || []); e.target.value = ""; upload(f); }} />
      {err && <p className="mt-3 text-sm text-[#B42318]" data-testid="contribute-error">{err}</p>}
      {done.length > 0 && <p className="mt-4 text-sm" data-testid="contribute-done">Added {done.length} photo{done.length > 1 ? "s" : ""}. Thank you.</p>}
    </main>
  );
}
